import { lazy } from 'react';
// import { USER_ROLE } from 'constants.js';
import { DEFAULT_PATHS } from 'config.js';
import { components } from 'react-select/dist/index-ea9e225d.cjs.prod';
// import { components } from 'react-select/dist/react-select.cjs.prod';

const ReviewerDashboard = lazy(() => import('Reviewer/ReviewerDashboard/ReviewerDashboard'));
const ReviewerArticles = lazy(() => import('Reviewer/ReviewerArticle/ReviewerArticle'));
// const ReviewerProfile = lazy(() => import('Reviewer/ReviewerProfile/ReviewerProfile'));
const ReviewForm = lazy(() => import('Reviewer/ReviewerArticle/ReviewForm'));
const Login = lazy(() => import('views/default/Login'));
const Profile = lazy(() => import('Reviewer/ReviewerProfile/ReviewerProfile'));
const ReviewerRevForm=lazy(()=>import('Reviewer/ReviewerArticle/ReviewerRevForm'))
// const dashboard = lazy(() => import('Reviewer/ReviewerDashboard/ReviewerDashboard'));
// const Articles = lazy(() => import('Reviewer/ReviewerArticle/ReviewerArticle'));
// const Profile = lazy(() => import('Reviewer/ReviewerProfile/ReviewerProfile'));


// const products = {
//   list: lazy(() => import('views/products/list/ProductsList')),
//   detail: lazy(() => import('views/products/detail/ProductsDetail')),
// };
// const orders = {
//   list: lazy(() => import('views/orders/list/OrdersList')),
//   detail: lazy(() => import('views/orders/detail/OrdersDetail')),
// };
// const customers = {
//   list: lazy(() => import('views/customers/list/CustomersList')),
//   detail: lazy(() => import('views/customers/detail/CustomersDetail')),
// };

// const storefront = {
//   home: lazy(() => import('views/storefront/home/Home')),
//   filters: lazy(() => import('views/storefront/filters/Filters')),
//   categories: lazy(() => import('views/storefront/categories/Categories')),
//   detail: lazy(() => import('views/storefront/detail/Detail')),
//   cart: lazy(() => import('views/storefront/cart/Cart')),
//   checkout: lazy(() => import('views/storefront/checkout/Checkout')),
//   invoice: lazy(() => import('views/storefront/invoice/Invoice')),
// };
// const shipping = lazy(() => import('views/shipping/Shipping'));
// const discount = lazy(() => import('views/discount/Discount'));

// const settings = {
//   home: lazy(() => import('views/settings/home/Home')),
//   general: lazy(() => import('views/settings/general/General')),
// };
const authordata = JSON.parse(localStorage.getItem('authorpayload'));

const appRoot = DEFAULT_PATHS.APP.endsWith('/') ? DEFAULT_PATHS.APP.slice(1, DEFAULT_PATHS.APP.length) : DEFAULT_PATHS.APP;

const ReviewerRoutesAndMenuItems = {
    mainMenuItems: [
        {
            path: DEFAULT_PATHS.APP,
            exact: true,
            redirect: true,
            // to: `${appRoot}/reviewer_dashboard`,
            to: `${appRoot}/reviewer_dashboard`,
        },
        {
            path: `${appRoot}/reviewer_dashboard`,
            component: ReviewerDashboard,
            label: 'Dashboard',
            icon: 'shop',
        },

        {
            path: `${appRoot}/reviewer_article`,
            component: ReviewerArticles,
            label: 'Articles',
            icon: 'shop'
        },
        // {
        //     path: `${appRoot}/reviewer_profile`,
        //     component: ReviewerProfile,
        //     label: 'ReviewerProfile',
        //     icon: 'shop'
        // },
        {
            path: `${appRoot}/reviewer_profile`,
            component: Profile,
            // label: 'Profile',
            // icon: 'shop'
        },
        {
            path: `${appRoot}/reviewform`,
            component: ReviewForm
        },
        {
            path: `${appRoot}/login`,
            component: Login,
            // label:"Login",
            // icon:"shop"
        },
        {
            path:`${appRoot}/ReviewerRevForm`,
            component:ReviewerRevForm
        }

    ],
    sidebarItems: [],
};
export default ReviewerRoutesAndMenuItems;
